import { render, staticRenderFns } from "./ChapterSessionDetail.vue?vue&type=template&id=110e67e6&scoped=true&"
import script from "./ChapterSessionDetail.vue?vue&type=script&lang=js&"
export * from "./ChapterSessionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110e67e6",
  null
  
)

export default component.exports